import {
    Component,
    ViewEncapsulation,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Inject
} from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { SharedMailComponent } from 'src/app/_shared/components/mail/shared-mail/shared-mail.component';
import { KAL_DIALOG_DATA, KalDialogRef } from '@kalidea/kaligraphi';
import { MailService } from 'src/app/_core/services/mail.service';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { BaseComponent } from 'src/app/_core/tools/base.component';

export interface SharedMailDeliveryDialogData {
    beneficiaryId: number;
    deliveryIdsList: number[];
}

@Component({
    selector: 'app-shared-mail-delivery-dialog',
    templateUrl: './shared-mail-delivery-dialog.component.html',
    styleUrls: ['./shared-mail-delivery-dialog.component.sass'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SharedMailDeliveryDialogComponent extends BaseComponent {

    formControl = new UntypedFormControl(null, [SharedMailComponent.Validator]);

    constructor(protected readonly cdr: ChangeDetectorRef,
                private readonly dialogRef: KalDialogRef<SharedMailDeliveryDialogComponent>,
                @Inject(KAL_DIALOG_DATA) public data: SharedMailDeliveryDialogData,
                private readonly mailService: MailService) {
        super(cdr);
    }

    get loading$(): Observable<boolean> {
        return this.mailService.loading$;
    }

    close() {
        this.dialogRef.close();
    }

    sendMail() {
        this.watch$ = this.mailService.sendMail({
            mail: this.formControl.value,
            mailParameters: {
                parameters: {listeIdBlBRString: this.data.deliveryIdsList?.join(',')},
                reportCode: 'BLR',
                benefId: this.data.beneficiaryId,
                mailCC: false
            }
        }).pipe(
            tap(() => this.close())
        );
    }
}
